import React from 'react';
import DTecImg from '../../assets/LogoDTec.png';
import VortexImg from '../../assets/Horizontal Escuro.svg';
import EuropeoImg from '../../assets/Europeo.png';
import RNPImg from '../../assets/RNP.png';

import { Container } from './styles';

const Footer = () => {
  return (
    <Container>
      <div id="images-start">
        <img src={VortexImg} alt="Vortex logo" />
        <img src={DTecImg} alt="DTec logo" />
        <img src={EuropeoImg} alt="Europeo logo" />
        <img src={RNPImg} alt="RNP logo" />
      </div>
      <div id="text-middle">
        Este projeto recebeu financiamento do Programa HORIZON 2020 da União Europeia sob acordo de subvenção nº 777082, 
        e do Ministério da Ciência, Tecnologia e Inovação do Brasil através da Rede Nacional de Pesquisa e Educação (RNP), acordo nº 3007.
      </div>
    </Container>
  );
}

export default Footer;